// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_2_wrapper__17gY8"};